import { createQueryKey } from '@vista-digital/utilities';
export const getQueryKeyForFilmAvailability = (filmAvailability) => {
    const { filmId, siteId } = filmAvailability;
    return createQueryKey({ filmId, siteId });
};
//# sourceMappingURL=film-availability-utils.js.map